module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    class: _vm.pageData ? '' : 'loading'
  }, [_c('page-header', {
    attrs: {
      "title": _vm.headerTitle,
      "image": _vm.headerImage
    }
  }), _vm._v(" "), _c('pencils-change-lives', {
    attrs: {
      "content": _vm.pageContent
    }
  }), _vm._v(" "), _c('more-stories', {
    attrs: {
      "stories": _vm.moreStories
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-013de0a1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OurStory.vue
// module id = 302
// module chunks = 1